"use strict";

import { addEvent } from "./addEvent/addEvent";
import { loadingEnd } from "./loading/loading";

addEvent(window, "load", function () {
  afterLoadStart();
});

function afterLoadStart() {
  loadingEnd();
}
